
export interface Variety {
    area_ha: number;
    campaign: number;
    crop_code: string;
    rotation: number;
    scs_subject_id: number;
    seed_variety_id: number | null;
    subject_id: number;
    subject_name: string;
    variety: string;
}

export interface DashboardVariety {
    agm_group_code: string;
    area_ha: number;
    campaign: number;
    crop_code: string;
    rotation: number;
    scs_subject_id: number;
    seed_variety_id: number;
    subject_id: number;
    subject_name: string;
    variety: string;
}

export interface VegetativeCycle {
    cycle_id: number;
    cycle_number: number;
    end_date: number;
    precocity_description: string;
    seed_code: string;
    seed_id: number;
    seed_name: string;
    seed_variety_id: number;
    start_date: number;
}

export interface VarietyBase {
    id: number | null;
    code: string;
    description: string;
}

export function fromVarietyToVarietyBase(e: Variety): VarietyBase {
    return {
        id: e.seed_variety_id,
        code: e.crop_code,
        description: e.variety,
    }
}
export function fromDashboardVarietyToVarietyBase(e: DashboardVariety): VarietyBase {
    return {
        id: e.seed_variety_id,
        code: e.crop_code,
        description: e.variety,
    }
}
export function fromVegetativeCycleToVarietyBase(e: VegetativeCycle): VarietyBase {
    return {
        id: e.seed_variety_id,
        code: e.seed_code,
        description: e.seed_name,
    }
}
